import { useLang } from "@/providers/langProvider";
import { ProgressBar } from "@/utils/bootstrap";
interface Props {
  title: string;
  total: number;
  value: number;
}
const ReviewsRatio: React.FC<Props> = ({ title, total, value }) => {
  const lang = useLang();
  const rtl = lang === "ar";
  return (
    <tr>
      <td style={{ paddingInlineEnd: 12, textAlign: rtl ? "right" : "left" }}>
        {title}
      </td>
      <td className="w-100 ratio-td">
        <ProgressBar
          max={total}
          now={value}
          variant="custom"
          className="rate-count"
        />
      </td>
      <td className="">{value}</td>
    </tr>
  );
};

export default ReviewsRatio;
